module.exports = __webpack_public_path__ + "img/SR.80342fda.svg";